export interface TenantProfileWorkStation {
  id: string;
  name: string;
  isSelected: boolean;
  inEdit?: boolean;
  tenantProfileId: number;
  orderPosition?: number;
}

export type CreateWorkStation = Pick<TenantProfileWorkStation, 'name' | 'tenantProfileId'>;

export const InitialWorkStation: TenantProfileWorkStation = {
  id: '',
  name: '',
  inEdit: true,
  isSelected: false,
  tenantProfileId: 0,
};